export default function Overline({ children, className = "", ...props }) {
  return (
    <div
      className={`inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.28em] text-cyan-600 ${className}`}
      {...props}
    >
      <span className="h-px w-6 bg-cyan-600/70" />
      {children}
    </div>
  );
}
